// ===============================
// HEADER BOOSTSHOP – JS
// - Calcul dynamique de la hauteur du header
// - Gestion du burger + menu mobile
// ===============================

(function () {
  function updateHeaderHeight() {
    var header = document.querySelector('[data-bs-header]');
    if (!header) return;

    var height = header.offsetHeight;
    document.documentElement.style.setProperty('--bs-header-height', height + 'px');
  }

  function initMobileMenu() {
    var burger = document.querySelector('[data-bs-burger]');
    var mobileNav = document.querySelector('[data-bs-mobile-nav]');
    var body = document.body;

    if (!burger || !mobileNav) return;

    burger.addEventListener('click', function () {
      var isOpen = burger.classList.toggle('is-open');
      mobileNav.classList.toggle('is-open', isOpen);
      body.classList.toggle('bs-no-scroll', isOpen);
      burger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });

    // Fermer le menu quand on clique sur un lien
    mobileNav.addEventListener('click', function (event) {
      if (event.target.tagName.toLowerCase() === 'a') {
        burger.classList.remove('is-open');
        mobileNav.classList.remove('is-open');
        body.classList.remove('bs-no-scroll');
        burger.setAttribute('aria-expanded', 'false');
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    updateHeaderHeight();
    initMobileMenu();
  });

  window.addEventListener('resize', function () {
    updateHeaderHeight();
  });
})();
